import React from 'react';
import * as Ons from 'react-onsenui';

class HoldButton extends React.Component {

    #timer;

    static defaultProps = { duration: 2000 }

    constructor( props ) {

        super( props );

        this.state = {
            duration: this.props.duration,
            pressing: false
        };

        this.handleButtonContextMenu = this.handleButtonContextMenu.bind( this );
        this.handleButtonPress       = this.handleButtonPress.bind( this );
        this.handleButtonRelease     = this.handleButtonRelease.bind( this );
        this.handleClick             = this.handleClick.bind( this );

    }

    handleButtonContextMenu( e ) {

        e.preventDefault();

    }

    handleButtonPress() {

        this.#timer = setTimeout( this.handleClick, this.state.duration );

        this.setState( { pressing: true } );

    }

    handleButtonRelease() {

        clearInterval( this.#timer );

        this.setState( { duration: 0, pressing: false } );

        this.resetProgress();

    }

    handleClick() {

        this.setState( { duration: 0, pressing: false } );

        this.resetProgress();

        this.props.onClick();

    }

    resetProgress() {

        setTimeout( () => this.setState( { duration: this.props.duration } ), 10 );

    }

    render() {

        return (

            <Ons.Button
                className="hold-button"
                disabled={this.props.disabled}
                modifier="large"
                onMouseDown={this.handleButtonPress}
                onMouseLeave={this.handleButtonRelease}
                onMouseUp={this.handleButtonRelease}
                onTouchEnd={this.handleButtonRelease}
                onTouchStart={this.handleButtonPress}
                onContextMenu={this.handleButtonContextMenu}
            >

                <div className={'progress' + ( this.state.pressing ? ' pressing' : '' )} style={{ transitionDuration: this.state.duration + 'ms' }}></div>

                {this.props.label}

            </Ons.Button>

        );

    }

}

export default HoldButton;